var _rect, _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfPtt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#FDD7A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 30.6667C22 25.9527 22 23.5957 23.4645 22.1312C24.9289 20.6667 27.286 20.6667 32 20.6667H37C41.714 20.6667 44.0711 20.6667 45.5355 22.1312C47 23.5957 47 25.9527 47 30.6667V39.0001C47 43.7141 47 46.0711 45.5355 47.5356C44.0711 49.0001 41.714 49.0001 37 49.0001H32C27.286 49.0001 24.9289 49.0001 23.4645 47.5356C22 46.0711 22 43.7141 22 39.0001V30.6667Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1966_10208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 26.4995C38.4284 26.4995 40.3926 26.4995 41.613 27.7199C42.8334 28.9402 42.8334 30.9044 42.8334 34.8328C42.8334 38.7612 42.8334 40.7254 41.613 41.9457C40.3926 43.1661 38.4284 43.1661 34.5 43.1661C30.5717 43.1661 28.6075 43.1661 27.3871 41.9457C26.1667 40.7254 26.1667 38.7612 26.1667 34.8328C26.1667 30.9044 26.1667 28.9402 27.3871 27.7199C28.6075 26.4995 30.5717 26.4995 34.5 26.4995Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4166 41.9161L34.5 34.8327M41.5833 27.7494L34.5 34.8327M41.5833 41.9161L34.5 34.8327",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44.0001C19.2386 44.0001 17 41.7615 17 39.0001V29.0001C17 22.7147 17 19.572 18.9526 17.6194C20.9052 15.6667 24.0479 15.6667 30.3333 15.6667H37C39.7614 15.6667 42 17.9053 42 20.6667",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1966_10208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 -1 44.5 44.8328)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfPtt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-ptt.7a3b2eb6dd86dd30472a3b1c3f06ab31.svg";